import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { BranchManagementLevelACQ0137 } from './branches/BranchACQ0137';
import { BranchACQ134VariantA } from './branches/BranchACQ134VariantA';
import { BranchACQ134VariantB } from './branches/BranchACQ134VariantB';
import { BranchACQ136 } from './branches/BranchACQ136';
import { BranchBIAB004, BranchBusinessBox } from './branches/BranchBIAB004';
import { BranchCampaignAssistant } from './branches/BranchCampaignAssistant';
import { BranchCmsBusinessMaturity } from './branches/BranchCmsBusinessMaturity';
import { BranchCrmSetup } from './branches/BranchCrmSetup';
import { BranchOptionalPhoneNumber } from './branches/BranchOptionalPhoneNumber';
import { BranchQuestionFallback } from './branches/BranchQuestionFallback';
import { ProductSetupUIBranch } from './branches/ProductSetupUIBranch';
import { BranchHubletACQ0138 } from './branches/BranchACQ0138';
import { BranchACQ134CompanySize } from './branches/BranchACQ134CompanySize';
const DefaultBranches = [BranchQuestionFallback];
const softwareSignupBranches = [...DefaultBranches, BranchOptionalPhoneNumber, BranchManagementLevelACQ0137, BranchHubletACQ0138, BranchACQ136];
export const FlowBranches = {
  [Flow.Crm]: [...softwareSignupBranches, BranchBIAB004, BranchBusinessBox, BranchCrmSetup, BranchACQ134VariantA, BranchACQ134VariantB, BranchACQ134CompanySize],
  [Flow.Marketing]: [...softwareSignupBranches, BranchCampaignAssistant, BranchACQ134VariantA, BranchACQ134VariantB, BranchACQ134CompanySize],
  [Flow.Sales]: [...softwareSignupBranches, ProductSetupUIBranch, BranchACQ134VariantA, BranchACQ134VariantB, BranchACQ134CompanySize],
  [Flow.Service]: [...softwareSignupBranches, BranchACQ134VariantA, BranchACQ134VariantB, BranchACQ134CompanySize],
  [Flow.CmsFree]: [BranchCmsBusinessMaturity, ...softwareSignupBranches]
};
export const getFlowBranches = () => {
  return FlowBranches[getFlowKey()] || DefaultBranches;
};